<template>
    <div class="block-box">
        <div class="block-item">
            <div :span="6" class="label">
                {{configData.title}}
            </div>
            <el-col :span="14" class="color-box">
                <div class="color-item">
                    <el-color-picker v-model="configData.color[0].item" show-alpha/>
                    <span class="span" @click="resetBgA(configData.color)">重置</span>
                </div>
            </el-col>
        </div>
    </div>
</template>

<script>
    export default {
        name: "colors",
        props: {
            configData: {
                type: Object,
                default: {}
            },
        },
        methods: {
            // 重置
            resetBgA (color) {
                this.configData.color[0].item = this.configData.default[0].item
            }
        }
    }
</script>

<style scoped>

</style>
